import { create } from "zustand";
import type { Language } from "@bongeunsa/i18n";
import { LANGUAGES, detectLanguage } from "@bongeunsa/i18n";

function getInitialLang(): Language {
  const stored = localStorage.getItem("lang") as Language | null;
  if (stored && (LANGUAGES as string[]).includes(stored)) return stored;
  return detectLanguage(navigator.language);
}

type LangStore = {
  lang: Language;
  setLang: (lang: Language) => void;
};

export const useLangStore = create<LangStore>((set) => ({
  lang: getInitialLang(),
  setLang: (lang) => {
    localStorage.setItem("lang", lang);
    set({ lang });
  },
}));
